import { sendClarityCustomEvent } from '@/shared/analytics/clarityCustomEvent'

export type CbamSimulationClarityEvent =
  | 'simulations:list:views'
  | 'simulations:create:submitted'
  | 'simulations:create:succeeded'
  | 'simulations:create:failed'
  | 'simulations:edit:submitted'
  | 'simulations:edit:succeeded'
  | 'simulations:edit:failed'
  | 'simulations:delete:succeeded'
  | 'simulations:delete:failed'
  | 'simulations:details:viewed'
  | 'simulations:good:create:submitted'
  | 'simulations:good:create:succeeded'
  | 'simulations:good:create:failed'
  | 'simulations:good:edit:submitted'
  | 'simulations:good:edit:succeeded'
  | 'simulations:good:edit:failed'
  | 'simulations:good:delete:succeeded'
  | 'simulations:good:delete:failed'
  | 'simulations:good:inspected'
  | 'simulations:good:liability-overview:opened'
  | 'simulations:modifiers:submitted'
  | 'simulations:modifiers:succeeded'
  | 'simulations:modifiers:failed'

export function trackCbamSimulationSignal(event: CbamSimulationClarityEvent): void {
  sendClarityCustomEvent(event)
}
